// extracted by mini-css-extract-plugin
export default {"EditUser":"edit-user_EditUser__E9klT","labelRow":"edit-user_labelRow__FBaP1","labelText":"edit-user_labelText__ZEJwD"};